import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import axios from 'axios';
import apiClient from '../../apiClient';
import { XR_MODULE_QR_LINK } from '../../apiClient/apiEndpoints';


const QRExpand = ({uuid}) => {
    const configData = useSelector((state) => state.configSlice);
    const [expandQR, setExpandQR] = useState(false);
    const [qRLink, setQRLink] = useState(null);

    const getQRCodeLink =async()=>{
        try {
            let data = await apiClient.get(`${configData.config.UNO_URL}${XR_MODULE_QR_LINK}/${uuid}`);
            setQRLink(data)        
        } catch (error) {
            console.error(error);
        }
       
    }

    useEffect(()=>{
        getQRCodeLink(uuid)
    },[uuid]);

    const handleDownloadQr = async() =>{
        const response = await axios.get(qRLink, {
            responseType: 'blob',
        });
         
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${uuid}-QR.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Cleanup
    }


    return (
        <>
            <div className="qr-options">
                <div>
                    <div className="modulepic justify-content-start">
                        <img src={qRLink} />
                    </div>
                </div>
                <div >
                    <label className="mb-2">QR Code</label>
                    <div className="modulebtns mt-3" style={{ height: "auto", flexDirection: "column", alignItems: "start", gap:"0.5rem" }}>
                        <button style={{ opacity: "1" }} onClick={() => setExpandQR(true)}>Expand QR</button>
                        <button style={{ opacity: "1" }} onClick={()=>handleDownloadQr(qRLink)}>Download QR</button>
                    </div>
                </div>
            </div>

            <Modal size="lg" centered className='qr-expand' show={expandQR} onHide={() => setExpandQR(false)}>
                <div className="modal-body">
                    <img src={qRLink} />
                </div>
            </Modal>
        </>
    )
}

export default QRExpand